import React from 'react';
import { CurrentUserContext } from './CurrentUserContext';
import { useGetCurrentUser } from './useGetCurrentUser';
import { GearIndex } from '../../Model/GearIndex';
import { USER_INDEX_SETTINGS_KEY } from '../../config/consts';
import { StorageHelper } from '../../helpers/StorageHelper';

interface CurrentUserProviderProps {
  children?: React.ReactNode;
}

export const CurrentUserProvider: React.FC<CurrentUserProviderProps> = ({ children }) => {
  const { data: currentUser, isLoading } = useGetCurrentUser();
  const [selectedIndex, setSelectedIndex] = React.useState<GearIndex>();

  React.useEffect(() => {
    if (!currentUser?.indexes?.length) {
      return;
    }

    const storedId = StorageHelper.get(USER_INDEX_SETTINGS_KEY);
    if (!storedId) {
      setSelectedIndex(currentUser.indexes[0]);
      return;
    }

    const foundIndex = currentUser.indexes.find(index => index.id === parseInt(storedId));

    setSelectedIndex(foundIndex ?? currentUser.indexes[0]);
  }, [currentUser]);

  const handleSetSelectedIndex = (index: GearIndex) => {
    setSelectedIndex(index);
    StorageHelper.set(USER_INDEX_SETTINGS_KEY, index.id);
  };

  return (
    <CurrentUserContext.Provider
      value={{
        currentUser,
        isLoading,
        selectedIndex,
        setSelectedIndex: handleSetSelectedIndex
      }}
    >
      {children}
    </CurrentUserContext.Provider>
  );
};
